import { inject } from '@angular/core';
import { Router } from '@angular/router';

import { LoginModel } from '../models';

export const getLoginModelFromNavigation = (): LoginModel => {
  const router = inject(Router);
  const navigation = router.currentNavigation();

  if (!navigation?.extras.state) {
    throw new Error('Missing navigation state');
  }

  const { username, password } = navigation.extras.state as LoginModel;

  if (!username || !password) {
    throw new Error('Missing username or password');
  }

  return { username, password };
};
